module.exports = __webpack_public_path__ + "img/9.b3af7bae.png";